export const HeadlineFont = `
  font-family: 'Caveat Brush', serif;
  font-weight: normal;
`;

export const Headline2ndFont = `
  font-family: Knewave, sans-serif;
  font-weight: normal;
`;

export const MonospaceFont = `
  font-family: monospace;
  font-weight: normal;
`;

export const ListStyleSymbolFont = `
  font-family: monospace;
`;

export const ActionFont = `
  font-family: 'Caveat Brush', monospace;
  font-weight: normal;
`;



// WEBPACK FOOTER //
// ./src/components/styles/fonts.js